
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import InternalUserProfile from '@/components/profile/InternalUserProfile';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { Navigate } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';

const InternalProfile = () => {
  const { user } = useInternalAuth();
  const isMobile = useIsMobile();

  // If no internal user is logged in, redirect to internal login
  if (!user) {
    return <Navigate to="/internal-login" replace />;
  }

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Show appropriate header based on device */}
      {isMobile ? <MobileHeader /> : <Header />}
      
      <main className={`${
        isMobile 
          ? 'pt-20 pb-20 px-4' 
          : 'pt-28 pb-6 px-4 md:px-6'
      }`}>
        <div className="max-w-6xl mx-auto">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-white mb-2">New School Profile</h1>
            <p className="text-gray-400">Manage your New School account settings and information</p>
          </div>
          <InternalUserProfile />
        </div>
      </main>
      
      {!isMobile && <Footer />}
      <MobileBottomNav />
    </div>
  );
};

export default InternalProfile;
